import React from "react"

import { over1400 } from "~css/breakpoints.module.scss"
import * as style from "./Control.module.scss"

const Intro = ({ microcopy }) => (
  <div className={[style.description, over1400].join(" ")}>
    {microcopy.text("explorer.messages.intro")}
  </div>
)

export default Intro
